import * as React from 'react';

const CreateCustomizedEditionNavbar: React.SFC<any> = () =>
  (<div className="customize-navbar-container">
    <div className="customize-navbar">
      <div className="left">
        <span>Create Customized Edition</span>
        <span className="vertical-line" />
        <span>
          <a className="focus-on-dark" href="https://support.quill.org/using-quill-tools/quill-lessons/how-do-i-customize-a-quill-lesson">Help</a>
        </span>
      </div>
      <div className="right" />
    </div>
  </div>)

export default CreateCustomizedEditionNavbar
